import { action, observable, computed } from 'mobx';

export default class PromptStore {
  @observable title = '';
  @observable message = '';
  @observable opened = false;
  @observable action = undefined;
  @observable content = '';

  @computed get openRound() {
    return this.content === 'openRound';
  }

  @computed get block() {
    return this.content === 'block';
  }

  @computed get upload() {
    return this.content === 'upload';
  }

  constructor() {
    this.onSubmit = (data) => this.submit(data);
    this.onClose = () => this.close();
  }

  @action open({ title, message, action, content }) {
    this.title = title;
    this.message = message;
    this.action = action;
    this.opened = true;
    this.content = content;
  }

  @action close() {
    this.opened = false;
    this.title = '';
    this.message = '';
    this.action = undefined;
    this.content = '';
  }

  @action submit(data) {
    if (this.action) {
      this.action(data);
    }
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/stores/PromptStore.js